/** Nav rail ids → aggregate tab keys, plus idle prefetch order/timing. */

export const TAB_FOR_NAV: Record<string, string> = {
  dashboard: "landing",
  growthForecast: "growth_forecast",
  transactions: "transactions",
  salesmarketing: "sales_marketing",
};

/** Tabs warmed in the background after landing (not including the active tab). */
export const IDLE_PREFETCH_TABS = [
  "growth_forecast",
  "transactions",
  "sales_marketing",
] as const;

/** Delay between idle prefetch steps so landing settle stays first. */
export const IDLE_PREFETCH_STAGGER_MS = 500;

/** Extra headroom after landing dispatch before the first idle step. */
export const IDLE_PREFETCH_LANDING_HEADROOM_MS = 2800;

export const aggregateTabForNav = (selectedItemId: string): string =>
  TAB_FOR_NAV[selectedItemId] ?? "landing";
